<template>
  <main class="home">
    <CreditLinePaymentWizard />
  </main>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import CreditLinePaymentWizard from "@/apps/credit-line/components/CreditLinePaymentWizard.vue";
import { setLanguage } from "@/apps/credit-line/helpers/translations.helper";
export default defineComponent({
  name: "CreditLinePaymentWizardView",
  components: {
    CreditLinePaymentWizard,
  },
  beforeMount() {
    setLanguage(this);
  },
});
</script>
